// Anonymous Pedigrees frontend gate. The backend strip/reject layer is
// authoritative (backend/util/anonymousPedigrees.js); these helpers decide
// what the UI shows. `anonymousPedigreesActive` is the RESOLVED flag returned
// by GET /settings/pedigree (global admin override || group setting).

// For PII input sections (person form fields, bulk-edit columns, create-modal
// name fields): FAIL CLOSED — while pedigreeSetting is still loading
// (undefined), keep the inputs hidden so they never flash open on an
// anonymous deployment. They appear once the settings fetch resolves.
export const isAnonymousOrLoading = (pedigreeSetting) =>
  !pedigreeSetting || pedigreeSetting.anonymousPedigreesActive === true;

// For secondary affordances that are backend-enforced anyway (import button,
// merge wizard entry, sidebar sections): fail open while loading to avoid
// hiding normal-deployment UI on first paint.
export const isAnonymousActive = (pedigreeSetting) =>
  pedigreeSetting?.anonymousPedigreesActive === true;

// Label keys that can render stored PII on canvas nodes. Clamped at render
// time — hiding the LabelsMenu checkboxes is not enough because defaults,
// group presets and persisted per-client configs all set these keys true.
export const PII_LABEL_KEYS = [
  'firstName',
  'lastName',
  'dob',
  'dod',
  'hospitalNumber',
  'externalPatientId'
];

// TGCLOUD-1670 — the member keys a data overlay must never render on an
// anonymous deployment. Derived from PII_LABEL_KEYS rather than restated, so a
// key added to the label clamp is covered here for free, plus `maidenName`,
// which the label set has no switch for and so was never on that list.
//
// The facts endpoint's projection is the primary control: no identifying field
// crosses the wire at all. This is the second line, covering the member record
// the client already holds.
export const PII_OVERLAY_KEYS = [...PII_LABEL_KEYS, 'maidenName'];

/** Strip identifying fields from an overlay match before it is displayed. */
export const clampOverlayDisplay = (match, anonymous) => {
  if (!anonymous || !match) return match;
  const clamped = { ...match };
  PII_OVERLAY_KEYS.forEach((key) => {
    delete clamped[key];
  });
  return clamped;
};

export const clampLabelsSet = (labelsSet, anonymous) => {
  if (!anonymous) return labelsSet;
  const clamped = { ...labelsSet };
  PII_LABEL_KEYS.forEach((key) => {
    clamped[key] = false;
  });
  return clamped;
};
